
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    creator: {
      type: Object,
      required: true,
    },
  },
});
